export default class MegaMenuVideos {
  constructor(megaMenu) {
    this.container = megaMenu
    this.playVideoButtons = this.container?.querySelectorAll('.megaMenu__play-video')

    if (!this.container) return

    this.handlePlayVideoButtons()
  }

  handlePlayVideoButtons() {
    this.playVideoButtons?.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.stopOtherVideos()
        this.loadVideo(button)
      })
    })
  }

  stopOtherVideos() {
    const videos = [...document.querySelectorAll('.video-iframe-wrapper')]
    videos?.forEach((video) => {
      video.remove()
    })
  }

  loadVideo(button) {
    const parent = button?.closest('.megaMenuMovieContainer')
    const embed = button?.dataset?.embed

    const iframe = this.prepareIFrame(embed, parent)
    parent.appendChild(iframe)
  }

  prepareIFrame(embed, parent) {
    const iframeWrapper = document.createElement('div')
    iframeWrapper.classList.add('video-iframe-wrapper')

    const closeIframeButton = document.createElement('button')
    closeIframeButton.classList.add('video-iframe-close-button')
    closeIframeButton.innerText = 'Zamknij'
    closeIframeButton.addEventListener('click', () => {
      this.removeIframe(parent)
    })

    iframeWrapper.appendChild(closeIframeButton)

    const iframe = document.createElement('iframe')
    iframe.classList.add('video-iframe')
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + embed + '?rel=0&showinfo=0&autoplay=1')

    iframeWrapper.appendChild(iframe)

    return iframeWrapper
  }

  removeIframe(parent) {
    const iframe = parent?.querySelector('.video-iframe-wrapper')
    parent.removeChild(iframe)
  }
}
